<div>
	<div fxLayout="row" fxLayoutAlign="center center">
		<h2 mat-dialog-title mat-dialog-content>{{ data.message }}</h2>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center">
		<button class="mat-raised-button" mat-button (click)="close()" color="blue">Close</button>
	</div>
</div>
